import { Box, Typography } from '@packages/shared';
import { ArrowLargeRight32 } from '@packages/themes/icons';
import { fontSwitcher } from '../../utils';
import type { FlexibleTeaserType } from './types';
import { styleHelperFontSize, styleHelperLineHeight } from './utils';

/**
 * This component shows editorial content of a teaser.
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const FlexibleTeaserItem = ({ data }: { data: FlexibleTeaserType }) => {
  const {
    field_headline: headline,
    field_text_subheadline: subHeadline,
    field_font: styleFont,
    field_font_subheadline: styleFontSubHeadline,
    field_negative_text_color: styleIsNegativeTextColor = false,
    field_size: styleSize = 'big',
    field_size_subheadline: styleSizeSubHeadline = 'small',
  } = data;

  const styleDefault = {
    display: 'block',
    color: styleIsNegativeTextColor ? 'text.light' : 'text.dark',
  };

  return (
    <Box
      sx={{
        ...styleDefault,
      }}
      component="span"
    >
      {headline && (
        <Typography
          component="span"
          className={`headline ${fontSwitcher(styleFont)}`}
          sx={{
            ...styleDefault,
            fontSize: styleHelperFontSize(styleSize),
            lineHeight: styleHelperLineHeight(styleSize),
          }}
        >
          {headline}
        </Typography>
      )}
      {subHeadline && (
        <Typography
          component="span"
          className={`sub-headline ${fontSwitcher(styleFontSubHeadline)}`}
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
            fontSize: styleHelperFontSize(styleSizeSubHeadline),
            lineHeight: styleHelperLineHeight(styleSizeSubHeadline),
            marginTop: 1,
          }}
        >
          {subHeadline}
        </Typography>
      )}
      <Box
        sx={(theme) => ({
          display: 'inline-block',
          color: styleIsNegativeTextColor ? 'text.light' : 'text.dark',
          fill: styleIsNegativeTextColor ? 'text.light' : 'text.dark',
          position: 'absolute',
          bottom: theme.spacing(2),
          right: theme.spacing(2),
          '& svg': {
            width: theme.spacing(2.5),
            height: theme.spacing(2.5),
          },
        })}
        component="span"
      >
        <ArrowLargeRight32
          sx={{
            color: styleIsNegativeTextColor ? 'text.light' : 'text.dark',
            fill: styleIsNegativeTextColor ? 'text.light' : 'text.dark',
          }}
        />
      </Box>
    </Box>
  );
};
